import { render } from "./ProductQuantityAlert.vue?vue&type=template&id=1af31b0b&scoped=true&ts=true"
import script from "./ProductQuantityAlert.vue?vue&type=script&lang=ts"
export * from "./ProductQuantityAlert.vue?vue&type=script&lang=ts"

import "./ProductQuantityAlert.vue?vue&type=style&index=0&id=1af31b0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af31b0b"]])

export default __exports__